import { apiFetch } from './apiClient';

export interface ChronosStatus {
  enabled: boolean;
  linked: boolean;
  /**
   * True when the user WAS linked but their Chronos refresh token has expired
   * or been revoked (the API self-healed the link to a broken state). `linked`
   * is false in this case; the UI surfaces a "reconnect" prompt rather than the
   * first-time "link" copy. Absent/false on a healthy or never-linked account.
   */
  needsReconnect?: boolean;
  staffId?: string;
  timeZoneName?: string;
  linkedAt?: string;
  lastUsedAt?: string;
}

export async function getStatus(token: string): Promise<ChronosStatus> {
  const res = await apiFetch('/chronos/oauth/status', { token, method: 'GET' });
  if (!res.ok) throw new Error(`status: ${res.status}`);
  return res.json() as Promise<ChronosStatus>;
}

export async function startLink(token: string): Promise<{ authorizeUrl: string }> {
  const res = await apiFetch('/chronos/oauth/start', { token, method: 'GET' });
  if (!res.ok) throw new Error(`start: ${res.status}`);
  return res.json() as Promise<{ authorizeUrl: string }>;
}

export async function unlink(token: string): Promise<void> {
  const res = await apiFetch('/chronos/oauth/link', { token, method: 'DELETE' });
  if (!res.ok && res.status !== 204) throw new Error(`unlink: ${res.status}`);
}
